export default function SignUp() {
  return <h1>SignUp</h1>;
}
